<template>
  <div class="qushi">
    <div id="qushi" :style="{ width: '100%', height: '100%' }"></div>
  </div>
</template>

<script>
export default {
  name: "qushiEch",
  data() {
    return {
      data: [],
    };
  },
  props: ["manageList"],
  watch: {
    manageList(val) {
      this.qushiEch(val);
    },
  },
  mounted() {
    if (this.manageList) {
      this.qushiEch(this.manageList);
    }
  },
  methods: {
    qushiEch(data) {
      let myChart = this.$echarts.init(document.getElementById("qushi"));
      let option = null;
      let dataList = data;
      option = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(17,95,182,0.5)",
          textStyle: {
            color: "#fff",
          },
          triggerOn: "mousemove",
          showContent: true,
        },
        grid: {
          left: "0",
          right: "0",
          bottom: "0%",
          top: "15%",
          containLabel: true,
        },
        xAxis: {
          axisLine: {
            lineStyle: {
              color: "#ebebeb",
            },
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          //轴线上的字
          axisLabel: {
            show: true,
            textStyle: {
              color: "#1f2b3a",
              fontSize: "14",
            },
          },
          data: data.map((res) => res.times),
        },
        yAxis: [
          {
            name: "",
            nameTextStyle: {
              color: "#1f2b3a",
            },
            type: "value",
            splitNumber: 4,
            axisTick: {
              show: false,
            },
            //轴线上的字
            axisLabel: {
              show: true,
              textStyle: {
                fontSize: "14",
                color: "#1f2b3a",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#ebebeb",
              },
            },
            //网格线
            splitLine: {
              lineStyle: {
                color: "#ebebeb",
              },
            },
          },
        ],
        series: [
          {
            name: "人",
            type: "line",
            smooth: true, //是否平滑曲线显示
            showSymbol: false,
            markPoint: {
              data: [
                {
                  name: "周最高",
                  value: 320,
                  xAxis: 4,
                  yAxis: 320,
                },
              ],
            },
            itemStyle: {
              color: "#F3A22D",
              borderColor: "#F3A22D",
              borderWidth: 1,
            },
            lineStyle: {
              normal: {
                width: 2,
                color: {
                  type: "linear",
                  colorStops: [
                    {
                      offset: 0,
                      color: "#F3A22D", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#F3A22D", // 100% 处的颜色
                    },
                  ],
                  globalCoord: false, // 缺省为 false
                },
                shadowColor: "#F3A22D",
                shadowBlur: 30,
                shadowOffsetY: 5,
              },
            },
            areaStyle: {
              //区域填充样式
              normal: {
                color: new this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(243,162,45, 0.6)",
                    },
                    {
                      offset: 0.6,
                      color: "rgba(243,162,45, 0.2)",
                    },
                    {
                      offset: 0.8,
                      color: "rgba(243,162,45, 0.1)",
                    },
                  ],
                  false
                ),
                shadowColor: "rgba(243,162,45, 0.1)",
                shadowBlur: 6,
              },
            },
            data: dataList,
          },
        ],
      };

      option && myChart.setOption(option);
      // if (option && typeof option === "object") {
      //   myChart.setOption(option, true);
      //   //  refreshChart(myChart,option);
      //   var index5 = 0; //播放所在下标
      //   var mTime = setInterval(function () {
      //     myChart.dispatchAction({
      //       type: "showTip",
      //       seriesIndex: 0,
      //       dataIndex: index5,
      //     });
      //     index5++;
      //     if (index5 >= 7) {
      //       //console.log('data4', fxdata.length)
      //       index5 = 0;
      //       //console.log(fxdata)
      //     }
      //   }, 2500);
      // }
      myChart.setOption(option);
    },
  },
};
</script>
<style scoped>
.qushi {
  height: 100%;
}
</style>
